module.exports = {
	en: {
		'feedback.teamSelectionSuccess':
			'You’ve successfully selected your team roster! Now it is time to pick a Team Captain. The Team Captain will be responsible for match check in.',
		'feedback.captainSelectionSuccess':
			'You’ve successfully designated a Captain! Your team is all set and can now begin individual registration. Please ask your teammates to register. All players on the team, including the team captain, must register to be able to participate.',
		'feedback.matchAcceptedByBothNotice':
			'Please wait, your match is being prepared. Do not leave Tournament Hub until your War is created.',
		'feedback.matchAcceptedNotice': 'Match accepted. Waiting for the opponent to accept...',
		'feedback.matchDeclinedNotice':
			'Your opponent has declined the match. You have been placed back into the queue.',
		'feedback.matchFoundNotice':
			'Match found! Accept the match to play now, or decline it to leave the queue.',
		'feedback.matchFound': 'Match Found',
	},
	fr: {
		'feedback.teamSelectionSuccess':
			"La sélection de votre équipe a réussi ! Il est temps de choisir un capitaine. Il sera responsable du tournoi et de l'enregistrement aux matchs.",
		'feedback.captainSelectionSuccess':
			"La sélection du capitaine a réussi ! Votre équipe est prête et peut s'inscrire dès maintenant. Demandez à votre équipe de s'inscrire pour pouvoir participer.",
		'feedback.matchAcceptedByBothNotice':
			'Patientez pendant la préparation de votre match. Ne quittez pas le portail du tournoi pendant la création de la guerre.',
		'feedback.matchAcceptedNotice': "Match accepté ! En attente de l'adversaire...",
		'feedback.matchDeclinedNotice':
			"L'adversaire a refusé le match. Vous avez été replacé dans la file.",
		'feedback.matchFoundNotice':
			'Match trouvé ! Acceptez le match pour jouer, ou refusez pour quitter la file.',
		'feedback.matchFound': 'Match trouvé',
	},
	it: {
		'feedback.teamSelectionSuccess':
			'La selezione della squadra è andata a buon fine! Ora non ti resta che scegliere il capitano, che sarà responsabile della registrazione al torneo e agli scontri.',
		'feedback.captainSelectionSuccess':
			'La scelta del capitano è andata a buon fine e la squadra è pronta a iscriversi. Chiedi agli altri membri di farlo per partecipare alla competizione. Ricorda che tutti, incluso il capitano, devono iscriversi per partecipare.',
		'feedback.matchAcceptedByBothNotice':
			'Preparazione dello scontro in corso... Non uscire dal Portale del Torneo finché la creazione della guerra non è stata completata.',
		'feedback.matchAcceptedNotice': "Scontro accettato. In attesa che l'avversario accetti...",
		'feedback.matchDeclinedNotice':
			"L'avversario ha rifiutato lo scontro, perciò sei di nuovo in coda.",
		'feedback.matchFoundNotice':
			'Scontro trovato! Accettalo per giocare subito oppure rifiutalo per abbandonare la coda.',
		'feedback.matchFound': 'Scontro trovato',
	},
	de: {
		'feedback.teamSelectionSuccess':
			'Deine Teamauswahl war erfolgreich! Jetzt ist es Zeit, einen Teamkapitän auszuwählen. Der Teamkapitän ist für den Turnier- und Match-Check-in verantwortlich.',
		'feedback.captainSelectionSuccess':
			'Deine Kapitänsauswahl war erfolgreich! Dein Team ist startklar und kann den Registrierungsprozess beginnen. Bitte dein Team darum, sich zu registrieren, um teilnehmen zu können.',
		'feedback.matchAcceptedByBothNotice':
			'Bitte warte einen Moment, dein Match wird vorbereitet. Verlasse den Turnier-Hub nicht, bevor dein Krieg zusammengestellt wurde.',
		'feedback.matchAcceptedNotice': 'Match angenommen. Auf Antwort des Gegners warten ...',
		'feedback.matchDeclinedNotice':
			'Dein Gegner hat das Match abgelehnt. Du wurdest wieder in der Warteschlange platziert.',
		'feedback.matchFoundNotice':
			'Match gefunden! Akzeptiere das Match, um jetzt zu spielen, oder lehne es ab, um die Warteschlange zu verlassen.',
		'feedback.matchFound': 'Match gefunden',
	},
	es: {
		'feedback.teamSelectionSuccess':
			'¡Selección de equipo completada! Ahora hay que escoger un capitán para el equipo. El capitán del equipo será responsable de registrarlo para el torneo y el partido.',
		'feedback.captainSelectionSuccess':
			'¡Selección de capitán completada! El equipo está listo para empezar el proceso de registro. Pide al equipo que se registre para participar.',
		'feedback.matchAcceptedByBothNotice':
			'Por favor, espera mientras preparamos tu partido. No abandones el portal del torneo hasta que se haya generado la guerra.',
		'feedback.matchAcceptedNotice': '¡Partido aceptado! Esperando a que el rival acepte...',
		'feedback.matchDeclinedNotice': 'Tu rival ha rechazado el partido. Has vuelto a la cola.',
		'feedback.matchFoundNotice':
			'¡Partido encontrado! Acepta el partido para jugar o recházalo para abandonar la cola.',
		'feedback.matchFound': 'Partido encontrado',
	},
	pt: {
		'feedback.teamSelectionSuccess':
			'Seleção de equipe concluída! É hora de escolher o capitão da equipe. O capitão da equipe será responsável pelo check-in do torneio e da disputa.',
		'feedback.captainSelectionSuccess':
			'Seleção de capitão concluída! Sua equipe está pronta e pode iniciar a inscrição. Peça que os integrantes da equipe se inscrevam para poderem participar.',
		'feedback.matchAcceptedByBothNotice':
			'Aguarde, sua disputa está sendo preparada. Não saia do portal do torneio enquanto sua guerra é criada.',
		'feedback.matchAcceptedNotice': 'Disputa aceita. Aguardando o adversário aceitar...',
		'feedback.matchDeclinedNotice':
			'O adversário recusou a disputa. Você está de volta na fila.',
		'feedback.matchFoundNotice':
			'Disputa encontrada! Aceite a disputa para jogar agora ou recuse para sair da fila.',
		'feedback.matchFound': 'Disputa encontrada',
	},
	jp: {
		'feedback.teamSelectionSuccess':
			'チームの編成が完了しました！次はチームキャプテンを選びましょう。チームキャプテンは、責任を持って大会およびマッチのチェックインを行う必要があります。',
		'feedback.captainSelectionSuccess':
			'キャプテンの選択が完了しました！チームの準備ができましたので、登録手続きを開始できます。参加登録を行うよう、チームのメンバーに連絡してください。出場するには、キャプテンを含め、すべてのメンバーが登録を完了する必要があります。',
		'feedback.matchAcceptedByBothNotice':
			'マッチの準備中です。お待ちください。対戦が組まれるまで大会ハブを退出しないでください。',
		'feedback.matchAcceptedNotice': 'マッチを承認しました。対戦相手の承認を待っています。',
		'feedback.matchDeclinedNotice':
			'対戦相手がマッチを拒否しました。あなたはキューに戻りました。',
		'feedback.matchFoundNotice':
			'対戦相手が見つかりました！承認して今すぐプレイするか、拒否してキューから出てください。',
		'feedback.matchFound': '対戦相手が見つかりました',
	},
	ko: {
		'feedback.teamSelectionSuccess':
			'팀 선택에 성공했습니다! 이제 팀 주장을 선택해야 합니다. 팀 주장은 토너먼트 및 매치 출석 확인에 대한 책임을 갖습니다.',
		'feedback.captainSelectionSuccess':
			'주장 선택에 성공했습니다! 내 팀의 준비가 완료되었으며 이제 등록 절차를 시작할 수 있습니다. 참여할 팀원들에게 등록을 요청하시기 바랍니다.',
		'feedback.matchAcceptedByBothNotice':
			'매치를 준비 중입니다. 잠시 기다려 주세요. 전쟁이 생성될 때까지 토너먼트 허브 화면을 떠나지 마세요.',
		'feedback.matchAcceptedNotice': '매치 수락됨. 상대방의 수락을 기다리고 있습니다...',
		'feedback.matchDeclinedNotice': '상대방이 매치를 거절했습니다. 다시 대기열로 돌아갑니다.',
		'feedback.matchFoundNotice':
			'매치 발견! 매치를 수락해 지금 플레이하거나 거절해 대기열로 돌아가세요.',
		'feedback.matchFound': '매치 발견',
	},
	zh_TW: {
		'feedback.teamSelectionSuccess':
			'隊伍陣容選擇完成！接下來請選擇隊伍隊長。隊伍隊長將負責賽事報到和單場比賽報到程序。',
		'feedback.captainSelectionSuccess':
			'隊伍隊長選擇完成！你的隊伍已經組建完成，可報名參賽。請聯絡你的隊伍成員完成報名，以便參加比賽。',
		'feedback.matchAcceptedByBothNotice':
			'請稍候，你的比賽正在準備中。在你的對戰建立前，請勿離開賽事中心。',
		'feedback.matchAcceptedNotice': '已接受對戰。等待對手接受對戰...',
		'feedback.matchDeclinedNotice': '你的對手已拒絕對戰。你已重新回到佇列中。',
		'feedback.matchFoundNotice': '配對成功！若接受則比賽立即開始，若拒絕則會離開佇列。',
		'feedback.matchFound': '配對成功',
	},
}
